import { Component, OnInit } from '@angular/core';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
  copyArrayItem,
} from '@angular/cdk/drag-drop';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatCard, MatCardContent } from '@angular/material/card';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { BlocksCreatorComponent } from '../blocks-creator/blocks-creator.component';
import { BlockCreatorService } from '../../services/block-creator.service';
import { Block } from '../../models/block.model';
import { ReceiptsService } from '../../services/receipts.service';
import { NotificationService } from '../../services/notification.service';

interface Receipt {
  voucherPrintout : {
    printDensity: number,
    codeTable: number,
    elements: any[],
    cut: {
      numberOfSteps: number,
      ledBlinking: boolean,
      ticketMovement: string,
      timeout: number
    }
  }
}

@Component({
    selector: 'app-receipt-creator',
    standalone: true,
    imports: [
        CdkDropList,
        CdkDrag,
        BlocksCreatorComponent,
        MatInputModule,
        MatFormFieldModule,
        FormsModule,
        MatCard,
        MatCardContent,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './receipt-creator.component.html',
    styleUrl: './receipt-creator.component.css'
})
export class ReceiptCreatorComponent implements OnInit {

  currentPrintout: Receipt;
  rekbotID: number = 1; 

  constructor(
    public blockService: BlockCreatorService,
    public receiptsService: ReceiptsService,
    public router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,

  ) {

    this.currentPrintout = {
      voucherPrintout : {
        printDensity: 4,
        codeTable: 45,
        elements: [],
        cut: {
          numberOfSteps: 16,
          ledBlinking: true,
          ticketMovement: "eject",
          timeout: 20
        }
      }
    }

  }

  printDensity: number = 4;
  codeTable: number = 45;
  numberOfSteps: number = 16;
  ledBlinking: boolean = true;
  ticketMovement: string = "eject";
  timeout: number = 20;

  receipt: Block[] = [];


  ngOnInit(): void {

    this.rekbotID = <number> this.route.snapshot.params['rekbotId'];

    if (this.rekbotID > 0) {
      this.blockService.setRekbotId(this.rekbotID);
      this.fetchReceipt();
    }
}

  drop(event: CdkDragDrop<Block[]>) {

    console.log("drop", event)

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);

      //console.log("change report", this.blocks);
      console.log("change report 2", this.receipt);
    } else {
      /*transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );*/
      copyArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  removeItem(item: any) {
    console.log("removeItem", item)

    const indexEl = this.receipt.indexOf(item, 0)

    console.log(this.receipt.find((el) => el== item));
    console.log("indexEl", indexEl);

    const removed = this.receipt.splice(indexEl, 1);
    console.log("removeItem", this.receipt)
  }

  saveReceipt() {
    console.log("saveReceipt", this.receipt)

    this.currentPrintout.voucherPrintout.printDensity = this.printDensity 
    this.currentPrintout.voucherPrintout.codeTable = this.codeTable 
    this.currentPrintout.voucherPrintout.cut.numberOfSteps = this.numberOfSteps 
    this.currentPrintout.voucherPrintout.cut.ledBlinking = this.ledBlinking 
    this.currentPrintout.voucherPrintout.cut.ticketMovement = this.ticketMovement 
    this.currentPrintout.voucherPrintout.cut.timeout = this.timeout 



    let elements = this.receipt.map( element => {
      let el = {}

      if(element.type === "text") {
        
        const isBold = (element.blockDetails?.textFormatting?.find((el) => el === "bold")) ? true : false;
        const isItalic = (element.blockDetails?.textFormatting?.find((el) => el === "italic")) ? true : false;
        const isUnderline = (element.blockDetails?.textFormatting?.find((el) => el === "uderline")) ? true : false;

        const textLines = (element.blockDetails?.textLines !== undefined ) ? element.blockDetails?.textLines : [];
        
        el = {
          type: "text",
          isBold: isBold,
          isItalic: isItalic,
          isUnderline: isUnderline,
          align: element.blockDetails?.align,
          fontType: element.blockDetails?.fontType,
          fontSize:  element.blockDetails?.fontSize,
          textLines: textLines
        }
      }

      if(element.type === "image") {

        el = {
          type: "image",
          imagePath: element.blockDetails?.imagePath,
          align: element.blockDetails?.align,
          height: element.blockDetails?.height,
          width: element.blockDetails?.width
        }
      }

      if(element.type === "barcode") {

        el = {
          type: "barcode",
          value: element.blockDetails?.value,
          barcode_type: element.blockDetails?.barcode_type,
          justification: element.blockDetails?.justification,
          textPosition: element.blockDetails?.textPosition,
          height: element.blockDetails?.height,
          width: element.blockDetails?.width
        }

      }

      return el
    })
    this.currentPrintout.voucherPrintout.elements = elements 

    //console.log("saveReceipt elements mapping", elements)

    const receiptString = JSON.stringify(this.currentPrintout)

    const payload = {
      rekbotId: this.rekbotID,
      receiptString: receiptString,
      receiptBlocks: this.receipt
    }

    //console.log("saveReceipt receiptString", receiptString)
    console.log("saveReceipt currentPrintout", receiptString)

    this.receiptsService.saveReceipt(this.rekbotID, payload)
    .subscribe({
      next: (response: any) => {
        console.log("saveReceipt", response);

        this.notificationService.pushNotification(
          `Paragon zapisany`, 'info', 5000);

      },
      error: (error) => {
        console.log("fetchSmtpConfig error", error)
        if(error.status === 401) {
          this.router.navigate(['/']);
        }
      }
      
    })

  }

  fetchReceipt() {
    this.receiptsService.fetchReceipt(this.rekbotID)
    .subscribe({
      next: (response: any) => {
        console.log("fetchReceipt response", response)

        this.receipt = response.receiptContents.map((item: any) => {
          let receiptItem = item.block
          receiptItem.blockDetails = JSON.parse(item.block.block_details)
          return receiptItem
        })

        /*response.receiptContents.forEach((item: any) => {
          const list = this.blockService.getList()
          const blockR = list.find( (block) => {block.id === item.receipt_block_id})
          console.log("finding", item, list)

          this.receipt.push(<Block> blockR)
        })*/

        /*this.blockService.attachList(response.blocksList.map((item: any) => {
          item.blockDetails = JSON.parse(item.block_details)
          return item
        }))*/
      },
      error: error => {
        if (error.status === 401) {
          this.router.navigate(['/']);
        }
      }
    })

  }
}
